import makeApiRequest from 'src/lib/makeApiRequest';
import { API_URL } from 'src/constants/Endpoints';
import { RecurringPayload } from 'src/models/RecurringModel';

export const postRecurringData =
(organisation: string, payload: RecurringPayload) => makeApiRequest({
  method: 'POST',
  url: `${API_URL.recurring}`,
  organisation,
  data: payload,
});

export const putRecurringData =
  (id: number, organisation: string, payload: RecurringPayload) => makeApiRequest({
    method: 'PUT',
    url: `${API_URL.recurring}/${id}`,
    organisation,
    data: payload,
  });

export const getRecurringData =
  (id: number, organisation: string) => makeApiRequest({
    method: 'GET',
    url: `${API_URL.recurring}/${id}`,
    organisation,
  });

export const deleteRecurringData =
  (id: number, organisation: string) => makeApiRequest({
    method: 'DELETE',
    url: `${API_URL.recurring}/${id}`,
    organisation,
  });
